import { useState } from "react";
import "./editorialForms.css";

export default function QuizForm({ data, onChange }) {
  const [questionInput, setQuestionInput] = useState("");
  const [editingQuestion, setEditingQuestion] = useState(null);

  const quizTypes = [
    { value: "general", label: "Conhecimentos Gerais" },
    { value: "educational", label: "Educacional" },
    { value: "entertainment", label: "Entretenimento" },
    { value: "professional", label: "Profissional" },
    { value: "trivia", label: "Trivia" },
    { value: "competitive", label: "Competitivo" },
  ];

  const categories = [
    "Ciência",
    "História",
    "Geografia",
    "Matemática",
    "Literatura",
    "Esportes",
    "Entretenimento",
    "Tecnologia",
    "Arte",
    "Música",
    "Cinema",
    "Política",
    "Economia",
    "Cultura Geral",
  ];

  const difficulties = [
    { id: "easy", name: "Fácil" },
    { id: "medium", name: "Médio" },
    { id: "hard", name: "Difícil" },
  ];

  const questionTypes = [
    { value: "multiple_choice", label: "Múltipla Escolha" },
    { value: "true_false", label: "Verdadeiro/Falso" },
    { value: "text", label: "Resposta Aberta" },
  ];

  const participantTypes = [
    { value: "public", label: "Público (Qualquer um pode participar)" },
    { value: "selected", label: "Selecionados (Apenas usuários específicos)" },
    { value: "restricted", label: "Restrito (Mediante convite)" },
  ];

  const handleAddQuestion = () => {
    if (questionInput.trim()) {
      const newQuestion = {
        question: questionInput.trim(),
        type: "multiple_choice",
        options: ["", "", "", ""],
        correctAnswer: "",
        points: 10,
        explanation: "",
      };
      
      onChange({
        ...data,
        questions: [...(data?.questions || []), newQuestion],
      });
      setQuestionInput("");
    }
  };

  const handleRemoveQuestion = (index) => {
    onChange({
      ...data,
      questions: (data?.questions || []).filter((_, i) => i !== index),
    });
  };

  const handleEditQuestion = (index, field, value) => {
    const questions = [...(data?.questions || [])];
    questions[index] = { ...questions[index], [field]: value };
    onChange({ ...data, questions });
  };

  const handleEditOption = (questionIndex, optionIndex, value) => {
    const questions = [...(data?.questions || [])];
    const options = [...questions[questionIndex].options];
    options[optionIndex] = value;
    questions[questionIndex] = { ...questions[questionIndex], options };
    onChange({ ...data, questions });
  };

  const handleAddOption = (questionIndex) => {
    const questions = [...(data?.questions || [])];
    questions[questionIndex].options.push("");
    onChange({ ...data, questions });
  };

  const handleRemoveOption = (questionIndex, optionIndex) => {
    const questions = [...(data?.questions || [])];
    questions[questionIndex].options = questions[questionIndex].options.filter((_, i) => i !== optionIndex);
    onChange({ ...data, questions });
  };

  return (
    <div className="editorial_form quiz_form">
      {/* Informações Básicas */}
      <div className="editorial_form_section">
        <label>
          Título do Quiz <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Quiz de História do Brasil"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o tema do quiz..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={500}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Quiz</label>
          <select
            value={data?.quizType || "general"}
            onChange={(e) => onChange({ ...data, quizType: e.target.value })}
          >
            {quizTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || "medium"}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Sistema de Pagamento */}
      <div className="editorial_form_section">
        <label className="editorial_form_checkbox">
          <input
            type="checkbox"
            checked={data?.isPaid || false}
            onChange={(e) => onChange({ ...data, isPaid: e.target.checked })}
          />
          <span>Quiz Pago (Pagar vencedores via Wallet Socializa)</span>
        </label>
      </div>

      {data?.isPaid && (
        <>
          <div className="editorial_form_row">
            <div className="editorial_form_section">
              <label>Quantos Vencedores Pagar?</label>
              <select
                value={data?.topWinners || 3}
                onChange={(e) => {
                  const topWinners = parseInt(e.target.value);
                  const prizePerWinner = data?.prizePerWinner || 0;
                  onChange({ 
                    ...data, 
                    topWinners,
                    totalPrizePool: topWinners * prizePerWinner
                  });
                }}
              >
                <option value={3}>Top 3 (1º, 2º e 3º lugar)</option>
                <option value={5}>Top 5 (1º ao 5º lugar)</option>
                <option value={10}>Top 10 (1º ao 10º lugar)</option>
                <option value={100}>Top 100 (1º ao 100º lugar)</option>
              </select>
            </div>

            <div className="editorial_form_section">
              <label>Valor por Vencedor (USD)</label>
              <input
                type="number"
                placeholder="Ex: 100"
                value={data?.prizePerWinner || ""}
                onChange={(e) => {
                  const prizePerWinner = parseFloat(e.target.value) || 0;
                  const topWinners = data?.topWinners || 3;
                  onChange({ 
                    ...data, 
                    prizePerWinner,
                    totalPrizePool: topWinners * prizePerWinner
                  });
                }}
              />
            </div>
          </div>

          {data?.prizePerWinner > 0 && data?.topWinners && (
            <div className="editorial_form_section">
              <div className="quiz_prize_summary">
                <h4>💰 Resumo de Prêmios</h4>
                <div className="prize_info">
                  <span>Cada vencedor receberá: <strong>${data.prizePerWinner} USD</strong></span>
                  <span>Total de vencedores: <strong>{data.topWinners}</strong></span>
                  <span className="total_prize">
                    Total a ser debitado da sua Wallet: 
                    <strong> ${(data.prizePerWinner * data.topWinners).toFixed(2)} USD</strong>
                  </span>
                </div>
                <p className="prize_note">
                  ⚠️ O valor total será debitado da sua Wallet no momento da criação do quiz.
                  Os prêmios serão distribuídos automaticamente aos vencedores quando o quiz 
                  atingir {data.topWinners} participantes completos.
                </p>
              </div>
            </div>
          )}
        </>
      )}

      {/* Controle de Participantes */}
      <div className="editorial_form_section">
        <label>Tipo de Participação</label>
        <select
          value={data?.participantType || "public"}
          onChange={(e) => onChange({ ...data, participantType: e.target.value })}
        >
          {participantTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      {(data?.participantType === "selected" || data?.participantType === "restricted") && (
        <div className="editorial_form_section">
          <label>Usuários Permitidos (IDs separados por vírgula)</label>
          <textarea
            placeholder="Ex: 123abc,456def,789ghi"
            value={(data?.allowedParticipants || []).join(",")}
            onChange={(e) =>
              onChange({
                ...data,
                allowedParticipants: e.target.value.split(",").map((id) => id.trim()),
              })
            }
            rows={2}
          />
        </div>
      )}

      <div className="editorial_form_section">
        <label>Máximo de Participantes (0 = ilimitado)</label>
        <input
          type="number"
          placeholder="Ex: 100"
          value={data?.maxParticipants || ""}
          onChange={(e) =>
            onChange({ ...data, maxParticipants: parseInt(e.target.value) || 0 })
          }
        />
      </div>

      {/* Configurações de Tempo */}
      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tempo Limite Total (minutos)</label>
          <input
            type="number"
            placeholder="Ex: 30"
            value={data?.timeLimit || ""}
            onChange={(e) =>
              onChange({ ...data, timeLimit: parseInt(e.target.value) || 0 })
            }
          />
          <span className="editorial_form_hint">0 = sem limite</span>
        </div>

        <div className="editorial_form_section">
          <label>Tempo por Pergunta (segundos)</label>
          <input
            type="number"
            placeholder="Ex: 60"
            value={data?.timeLimitPerQuestion || ""}
            onChange={(e) =>
              onChange({
                ...data,
                timeLimitPerQuestion: parseInt(e.target.value) || 0,
              })
            }
          />
          <span className="editorial_form_hint">0 = sem limite</span>
        </div>
      </div>

      {/* Data de Início e Fim */}
      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Data de Início</label>
          <input
            type="datetime-local"
            value={data?.startDate || ""}
            onChange={(e) => onChange({ ...data, startDate: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Data de Término</label>
          <input
            type="datetime-local"
            value={data?.endDate || ""}
            onChange={(e) => onChange({ ...data, endDate: e.target.value })}
          />
        </div>
      </div>

      {/* Perguntas */}
      <div className="editorial_form_section">
        <label>
          Perguntas ({(data?.questions || []).length})
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddQuestion}
          >
            + Adicionar Pergunta
          </button>
        </label>
        <input
          type="text"
          placeholder="Digite a pergunta..."
          value={questionInput}
          onChange={(e) => setQuestionInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddQuestion()}
        />
      </div>

      {/* Lista de Perguntas */}
      {(data?.questions || []).map((q, qIndex) => (
        <div key={qIndex} className="quiz_question_editor">
          <div className="quiz_question_header">
            <h4>Pergunta {qIndex + 1}</h4>
            <button
              type="button"
              className="remove_variant_btn"
              onClick={() => handleRemoveQuestion(qIndex)}
            >
              Remover
            </button>
          </div>

          <div className="editorial_form_section">
            <label>Texto da Pergunta</label>
            <input
              type="text"
              value={q.question}
              onChange={(e) =>
                handleEditQuestion(qIndex, "question", e.target.value)
              }
            />
          </div>

          <div className="editorial_form_row">
            <div className="editorial_form_section">
              <label>Tipo de Pergunta</label>
              <select
                value={q.type || "multiple_choice"}
                onChange={(e) =>
                  handleEditQuestion(qIndex, "type", e.target.value)
                }
              >
                {questionTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="editorial_form_section">
              <label>Pontos</label>
              <input
                type="number"
                value={q.points || 10}
                onChange={(e) =>
                  handleEditQuestion(qIndex, "points", parseInt(e.target.value) || 10)
                }
              />
            </div>
          </div>

          {/* Opções de Resposta */}
          {q.type === "multiple_choice" && (
            <div className="editorial_form_section">
              <label>
                Opções de Resposta
                <button
                  type="button"
                  className="add_variant_btn"
                  onClick={() => handleAddOption(qIndex)}
                >
                  + Adicionar Opção
                </button>
              </label>
              {q.options.map((option, oIndex) => (
                <div key={oIndex} className="variant_row">
                  <input
                    type="text"
                    placeholder={`Opção ${oIndex + 1}`}
                    value={option}
                    onChange={(e) =>
                      handleEditOption(qIndex, oIndex, e.target.value)
                    }
                  />
                  {q.options.length > 2 && (
                    <button
                      type="button"
                      className="remove_variant_btn"
                      onClick={() => handleRemoveOption(qIndex, oIndex)}
                    >
                      x
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Resposta Correta */}
          <div className="editorial_form_section">
            <label>Resposta Correta</label>
            {q.type === "multiple_choice" && (
              <select
                value={q.correctAnswer || ""}
                onChange={(e) =>
                  handleEditQuestion(qIndex, "correctAnswer", e.target.value)
                }
              >
                <option value="">Selecione a resposta correta</option>
                {q.options.map((option, i) => (
                  <option key={i} value={option}>
                    {option || `Opção ${i + 1}`}
                  </option>
                ))}
              </select>
            )}
            {q.type === "true_false" && (
              <select
                value={q.correctAnswer}
                onChange={(e) =>
                  handleEditQuestion(qIndex, "correctAnswer", e.target.value === "true")
                }
              >
                <option value="true">Verdadeiro</option>
                <option value="false">Falso</option>
              </select>
            )}
            {q.type === "text" && (
              <input
                type="text"
                placeholder="Resposta esperada"
                value={q.correctAnswer || ""}
                onChange={(e) =>
                  handleEditQuestion(qIndex, "correctAnswer", e.target.value)
                }
              />
            )}
          </div>

          <div className="editorial_form_section">
            <label>Explicação (opcional)</label>
            <textarea
              placeholder="Explique por que essa é a resposta correta..."
              value={q.explanation || ""}
              onChange={(e) =>
                handleEditQuestion(qIndex, "explanation", e.target.value)
              }
              rows={2}
            />
          </div>
        </div>
      ))}

      {/* Configurações Avançadas */}
      <div className="editorial_form_section">
        <label>Configurações Avançadas</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="shuffleQuestions"
              checked={data?.shuffleQuestions || false}
              onChange={(e) =>
                onChange({ ...data, shuffleQuestions: e.target.checked })
              }
            />
            <label htmlFor="shuffleQuestions">Embaralhar perguntas</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="shuffleOptions"
              checked={data?.shuffleOptions || false}
              onChange={(e) =>
                onChange({ ...data, shuffleOptions: e.target.checked })
              }
            />
            <label htmlFor="shuffleOptions">Embaralhar opções de resposta</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="showCorrectAnswers"
              checked={data?.showCorrectAnswers !== false}
              onChange={(e) =>
                onChange({ ...data, showCorrectAnswers: e.target.checked })
              }
            />
            <label htmlFor="showCorrectAnswers">
              Mostrar respostas corretas no final
            </label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="showResultsImmediately"
              checked={data?.showResultsImmediately !== false}
              onChange={(e) =>
                onChange({ ...data, showResultsImmediately: e.target.checked })
              }
            />
            <label htmlFor="showResultsImmediately">
              Mostrar resultados imediatamente
            </label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowRetake"
              checked={data?.allowRetake || false}
              onChange={(e) =>
                onChange({ ...data, allowRetake: e.target.checked })
              }
            />
            <label htmlFor="allowRetake">Permitir refazer o quiz</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="certificateEnabled"
              checked={data?.certificateEnabled || false}
              onChange={(e) =>
                onChange({ ...data, certificateEnabled: e.target.checked })
              }
            />
            <label htmlFor="certificateEnabled">Gerar certificado de conclusão</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Pontuação Mínima para Aprovação (%)</label>
        <input
          type="number"
          placeholder="Ex: 70"
          min="0"
          max="100"
          value={data?.passingScore || ""}
          onChange={(e) =>
            onChange({ ...data, passingScore: parseInt(e.target.value) || 0 })
          }
        />
        <span className="editorial_form_hint">
          Deixe em branco para não exigir pontuação mínima
        </span>
      </div>
    </div>
  );
}
